import { GetContentPackageDiscussionByIdAndEmailMeta, GetContentPackageDiscussionByIdAndEmailPayload } from 'types/store/GetContentPackageDiscussionByIdAndEmail';
import { createAsyncReducer } from 'utils/Redux';

import { getContentPackageDiscussionByIdAndEmailActions } from '../actions';

export default createAsyncReducer<GetContentPackageDiscussionByIdAndEmailMeta, GetContentPackageDiscussionByIdAndEmailPayload>(getContentPackageDiscussionByIdAndEmailActions);
